import 'react-toastify/dist/ReactToastify.css';
import './app.scss';
import 'app/config/dayjs.ts';
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { hot } from 'react-hot-loader';
import Sidebar from 'app/shared/layout/sidebar/sidebar';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getSession } from 'app/shared/reducers/authentication';
import { getProfile } from 'app/shared/reducers/application-profile';
import { Card } from 'antd';
import Header from 'app/shared/layout/header/header';
import Footer from 'app/shared/layout/footer/footer';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import ErrorBoundary from 'app/shared/error/error-boundary';
import { AUTHORITIES } from 'app/config/constants';
import AppRoutes from 'app/routes';
import { Layout } from 'antd';
const { Sider, Content } = Layout;
const baseHref = document.querySelector('base').getAttribute('href').replace(/\/$/, '');

export const App = () => {
  const dispatch = useAppDispatch();
  const [collapsed, setCollapsedState] = useState(true);
  const handleCollapse = () => {
    setCollapsedState(!collapsed);
  };

  useEffect(() => {
    dispatch(getSession());
    dispatch(getProfile());
  }, []);

  const currentLocale = useAppSelector(state => state.locale.currentLocale);
  const isAuthenticated = useAppSelector(state => state.authentication.isAuthenticated);
  const isAdmin = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.ADMIN]));
  const isComptable = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.COMPTABLE]));
  const isDirecteur = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.DIRECTEUR]));
  const isDirecteurEtude = useAppSelector(state =>
    hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.DIRECTEUR_ETUDE])
  );
  const isProfesseur = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.PROFESSEUR]));
  const account = useAppSelector(state => state.authentication.account);
  const ribbonEnv = useAppSelector(state => state.applicationProfile.ribbonEnv);
  const isInProduction = useAppSelector(state => state.applicationProfile.inProduction);
  const isOpenAPIEnabled = useAppSelector(state => state.applicationProfile.isOpenAPIEnabled);
  return (
    <Router basename={baseHref}>
      <div className="app-container">
        <ToastContainer position={toast.POSITION.TOP_LEFT} className="toastify-container" toastClassName="toastify-toast" />
        <ErrorBoundary>
          <Header
            isAuthenticated={isAuthenticated}
            isAdmin={isAdmin}
            role={account.authorities}
            currentLocale={currentLocale}
            ribbonEnv={ribbonEnv}
            isInProduction={isInProduction}
            isOpenAPIEnabled={isOpenAPIEnabled}
          />
        </ErrorBoundary>
        <div className="container-fluid m-0 p-0">
          {isAuthenticated ? (
            <div>
              <Layout style={{ paddingTop: 50 }}>
                <Sidebar
                  isAuthenticated={isAuthenticated}
                  isAdmin={isAdmin}
                  isProfesseur={isProfesseur}
                  isComptable={isComptable}
                  isDirecteur={isDirecteur}
                  isDirecteurEtude={isDirecteurEtude}
                  collapsed={collapsed}
                  handleCollapse={handleCollapse}
                />
                <Layout style={{ width: 'auto', height: '100vh', overflowY: 'scroll' }}>
                  <Content>
                    <div className="content">
                      <ErrorBoundary>
                        <AppRoutes />
                      </ErrorBoundary>
                    </div>
                  </Content>
                  <Footer />
                </Layout>
              </Layout>
            </div>
          ) : (
            <div className="container-fluid view-container" id="app-view-container">
              <Card className="jh-card">
                <ErrorBoundary>
                  <AppRoutes />
                </ErrorBoundary>
              </Card>
              <Footer />
            </div>
          )}
        </div>
      </div>
    </Router>
  );
};
export default hot(module)(App);
